import { withAsyncLoading } from '../../../libs/IdeLink.Web.Common/src/components/withAsyncLoading';

export const Page403Loading = withAsyncLoading(async () => import('./Page403').then(res => res.Page403));

